import {Trans} from 'react-i18next'
const symptomSelector=<Trans i18nKey="findcareoption.Start.Symptom_List_Selector"></Trans>
const nlpSelector = <Trans i18nKey="findcareoption.Start.NLP_Symptom_Selector"></Trans>
export default ({ fields, setFields, }) =>
    <div className="standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center standby-form-fieldset">
        <div className="standby-col standby-col-shrink standby-form-legend">
            {/* <div className="standby-form-legend-text">
            <Trans i18nKey="findcareoption.Start.Triageengine">Triage Engine</Trans>
      </div> */}
        </div>
        <div>
            {/* <label className="standby-tragesymptom-label">
                <input
                    type="radio"
                    name="triageSymptom"
                    value="symptomlistSelector"
                    className="standby-triagesymptom"
                    defaultChecked={fields.triageSymptom === 'symptomlistSelector'}
                    onClick={() => setFields({ triageSymptom: 'symptomlistSelector' })
                        //console.log(fields.triageSymptom);
                    }
                />{symptomSelector} 
      </label> */}
        </div>
        <div>
            {/* <label className="standby-tragesymptom-label">
                <input
                    type="radio"
                    name="triageSymptom"
                    value="NLPSymptomSelector"
                    className="standby-triagesymptom"
                    defaultChecked={fields.triageSymptom === 'NLPSymptomSelector'}
                    onClick={() => setFields({ triageSymptom: 'NLPSymptomSelector' })
                    }
                />{nlpSelector}
      </label> */}
        </div>
    </div>

